import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmsnseToEsmPipe } from './emsnse-to-esm.pipe';

@NgModule({
    declarations: [EmsnseToEsmPipe],
    exports: [
        EmsnseToEsmPipe
    ],
    imports: [
        CommonModule
    ]
})
export class EsmnseToEsmModule { }
